import script from "./TeamInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamInvite.vue?vue&type=script&setup=true&lang=js"

import "./TeamInvite.vue?vue&type=style&index=0&id=a9184402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9184402"]])

export default __exports__